/**
 * Mixpanel Analytics Provider
 * Implementation of AnalyticsProvider using Mixpanel SDK
 */

import mixpanel from "mixpanel-browser";
import type {
  AnalyticsProvider,
  AnalyticsProperties,
} from "./AnalyticsProvider";

export class MixpanelProvider implements AnalyticsProvider {
  private readonly token: string;
  private readonly debug: boolean;

  constructor(token: string, debug: boolean = false) {
    this.token = token;
    this.debug = debug;
  }

  init(): void {
    mixpanel.init(this.token, {
      debug: this.debug,
      track_pageview: true,
      persistence: "localStorage",
    });
  }

  identify(userId: string, properties?: AnalyticsProperties): void {
    mixpanel.identify(userId);
    if (properties) {
      mixpanel.people.set(properties);
    }
  }

  track(eventName: string, properties?: AnalyticsProperties): void {
    mixpanel.track(eventName, properties);
  }

  setUserProperties(properties: AnalyticsProperties): void {
    mixpanel.people.set(properties);
  }

  reset(): void {
    mixpanel.reset();
  }
}
